/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom'
import { PageTitle } from '../../../core'

import {
  KTCard,
  KTCardBody,
  Notes,
  DeleteModal,
  ArchiveModal,
  Select,
  DataTables,
  CheckoutDetail,
  Category,
  StatementModal,
  ContentModal,
  ExpensesFast,
  ExpensesDetail,
  InputPrice,
  Loading,
  Datepicker,
} from '../../../components'
import { useDispatch, useSelector } from 'react-redux'

import { SourceType, KTSVG, detailPageUrl, DetailPage, ExpenseDetailPage } from '../../../helpers'

import { companyGetId, companyDelete, companyArchiving } from '../../../redux/slices/company.slice'
import {
  bankCashAccountGetAll,
  basicLookup,
  usableCheckLookup,
  projectLookup,
} from '../../../redux/slices/lookup.slice'
import { accountSearchTransactions } from '../../../redux/slices/account.slice'
import {
  checkoutCompanyPayment,
  checkoutCompanyCollection,
  checkoutCompanyPayNewCheck,
  checkoutCompanyPayCheckout,
} from '../../../redux/slices/checkout.slice'

import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import Dropdown from 'react-bootstrap/Dropdown'

import * as Yup from 'yup'
import { useFormik } from 'formik'
import {
  useMemoizedPageUrl,
  useMemoizedValidationSchema,
  useMemoizedFormValues,
  useMemoizedBreadcrumbs,
  useMemoizedHandlers
} from '../../../utils/performanceOptimizations'

const selectCompanyData = (state) => ({
  detail: state.company.detail,
  isDeleted: state.company.isDeleted,
  isArchived: state.company.isArchived,
  error: state.company.error,
  loading: state.company.loading
})

const selectLookupData = (state) => ({
  accountLookupList: state.lookup.accountLookupList,
  Bank: state.lookup.Bank,
  usablecheckLookup: state.lookup.usablecheckLookup,
  projectLookupList: state.lookup.projectLookupList
})

const selectCheckoutData = (state) => ({
  transaction: state.checkout.transaction,
  companyNewCheck: state.checkout.companyNewCheck,
  companyCheckCheckout: state.checkout.companyCheckCheckout
})

const selectAccountData = (state) => ({
  accountList: state.account.accountList
})

const selectExpenseInvoiceData = (state) => ({
  isRedirect: state.expenseinvoice.isRedirect
})

function Detail() {
  const [show, setShow] = useState(false)
  const [showArchive, setShowArchive] = useState(false)
  const [showStatement, setShowStatement] = useState(false)
  const [showExpensesFast, setShowExpensesFast] = useState(false)
  const [showExpensesDetail, setShowExpensesDetail] = useState(false)
  const [activeTab, setActiveTab] = useState('payment')
  const [checkoutId, setCheckoutId] = useState()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const intl = useIntl()
  const pageUrl = useMemoizedPageUrl(location)

  const { detail, isDeleted, isArchived, error, loading } = useSelector(selectCompanyData)
  const { accountLookupList, Bank, usablecheckLookup, projectLookupList } = useSelector(selectLookupData)
  const { transaction, companyNewCheck, companyCheckCheckout } = useSelector(selectCheckoutData)
  const { accountList } = useSelector(selectAccountData)
  const { isRedirect } = useSelector(selectExpenseInvoiceData)
  const dispatch = useDispatch()

  const handlers = useMemoizedHandlers({
    handleDelete: () => dispatch(companyDelete({ id })),
    handleArchive: () => dispatch(companyArchiving({ id })),
    handleSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      if (activeTab === 'payment') {
        dispatch(checkoutCompanyPayment(values))
      } else if (activeTab === 'collection') {
        dispatch(checkoutCompanyCollection(values))
      } else if (activeTab === 'newcheck') {
        dispatch(checkoutCompanyPayNewCheck(values))
      } else {
        dispatch(checkoutCompanyPayCheckout(values))
      }

      formik.setFieldValue('Payment', 0)
      formik.setFieldValue('TotalPrice', 0)
      formik.setFieldValue('Name', '')
      formik.setFieldValue('Description', '')
    }
  }, {
    handleDelete: [dispatch, id],
    handleArchive: [dispatch, id],
    handleSubmit: [dispatch, activeTab]
  })

  const [stepSchema, setStepSchema] = useState({
    PaymentDate: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
    FromAccountId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
    Amount: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
  })

  const validSchema = useMemoizedValidationSchema(() => Yup.object().shape(stepSchema), [stepSchema])

  const formValues = useMemoizedFormValues({
    CompanyId: id,
    PaymentDate: new Date(),
    FromAccountId: '',
    ToAccountId: '',
    Amount: 0,
    Name: '',
    DefermentDate: new Date(),
    EditDate: new Date(),
    BankId: '',
    CheckNo: '',
    Description: '',
    TotalPrice: 0,
    CheckId: '',
    ToCompanyId: id,
    ProjectId: null,
    IsOfficial: true,
  })

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: handlers.handleSubmit,
  })

  useEffect(() => {
    formik.setFieldValue('PaymentDate', new Date())
    formik.setFieldValue('DefermentDate', new Date())
    formik.setFieldValue('EditDate', new Date())
    formik.setFieldValue('FromAccountId', '')
    formik.setFieldValue('ToAccountId', '')
    formik.setFieldValue('Amount', '')
    formik.setFieldValue('Name', '')
    formik.setFieldValue('BankId', '')
    formik.setFieldValue('CheckNo', '')
    formik.setFieldValue('Description', '')
    formik.setFieldValue('TotalPrice', '')
    formik.setFieldValue('CheckId', '')
    formik.setFieldValue('ProjectId', null)
    formik.setFieldValue('IsOfficial', true)

    if (activeTab === 'payment') {
      setStepSchema({
        PaymentDate: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        FromAccountId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        Amount: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        ProjectId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
      })
    } else if (activeTab === 'collection') {
      setStepSchema({
        PaymentDate: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        ToAccountId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        Amount: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        ProjectId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
      })
    } else if (activeTab === 'check') {
      setStepSchema({
        CheckId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
      })
    } else if (activeTab === 'newcheck') {
      setStepSchema({
        BankId: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        CheckNo: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        DefermentDate: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        EditDate: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
        TotalPrice: Yup.string().required(intl.formatMessage({ id: 'REQUIRED.GENERAL' })),
      })
    }
  }, [activeTab, intl])

  useEffect(() => {
    dispatch(companyGetId(id))
    dispatch(bankCashAccountGetAll())
    dispatch(basicLookup('Bank'))
    dispatch(usableCheckLookup())
    dispatch(projectLookup())
  }, [dispatch, id, transaction, companyNewCheck, companyCheckCheckout, isRedirect])

  useEffect(() => {
    if (detail && detail.accountId) {
      dispatch(accountSearchTransactions({ id: detail.accountId }))
    }
  }, [detail, dispatch])

  useEffect(() => {
    if (isDeleted || isArchived) navigate(`/${pageUrl[1]}/${pageUrl[2]}`)
  }, [isDeleted, isArchived, navigate, pageUrl])

  useEffect(() => {
    if (isRedirect) {
      setShowExpensesDetail(false)
      setShowExpensesFast(false)
    }
  }, [isRedirect])

  const breadcrumbs = useMemoizedBreadcrumbs(() => [
    {
      title: intl.formatMessage({ id: 'BC.SUPPLIER' }),
      path: '/expenses/supplier',
      isSeparator: false,
      isActive: false,
    },
  ], [intl])

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>
        {intl.formatMessage({ id: 'BC.SUPPLIER.DETAIL' })}
      </PageTitle>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-9'>
          {detail && (
            <>
              <KTCard className='mb-5'>
                <KTCardBody className='p-9'>
                  <div className='d-flex flex-wrap'>
                    <div className='flex-grow-1 w-100'>
                      <div className='d-flex justify-content-between align-items-start flex-wrap mb-5 row'>
                        <div className='d-flex flex-column col-xl-7'>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='text-gray-900 fs-2 fw-bold me-1'>{detail.name}</div>

                            <div className='ms-5'></div>
                          </div>

                          <div className='d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2'>
                            {detail?.phone && (
                              <>
                                <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                                  <KTSVG
                                    path='/images/icons/duotune/communication/com003.svg'
                                    className='svg-icon svg-icon-2 fs-4 me-1'
                                  />
                                  {detail.phone}
                                </div>
                              </>
                            )}

                            {detail?.email && (
                              <>
                                <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                                  <KTSVG
                                    path='/images/icons/duotune/communication/com011.svg'
                                    className='svg-icon svg-icon-2 fs-4 me-1'
                                  />
                                  {detail.email}
                                </div>
                              </>
                            )}

                            <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                              <KTSVG
                                path='/images/icons/duotune/general/gen018.svg'
                                className='svg-icon svg-icon-2 fs-4 me-1'
                              />
                              {detail.address} {detail.postalCode} {detail.provinceName} -{' '}
                              {detail.districtName}
                            </div>
                          </div>
                        </div>

                        <div className='d-flex gap-3 align-items-center col-xl-5 justify-content-end'>
                          <Category SourceId={Number(id)} SourceTypeId={SourceType.Company} />
                          <Link
                            to={`/${pageUrl[1]}/${pageUrl[2]}/edit/${id}`}
                            className='btn btn-sm btn-primary align-self-center'
                          >
                            <KTSVG
                              path='/images/icons/duotune/general/gen055.svg'
                              className='svg-icon-2'
                            />
                            {intl.formatMessage({ id: 'BUTTON.EDIT' })}
                          </Link>
                          <Dropdown autoClose='outside' align={{ lg: 'end' }}>
                            <Dropdown.Toggle
                              variant='secondary'
                              size='sm'
                              className='iconless ps-3 pe-3'
                            >
                              <KTSVG
                                path='/images/icons/duotune/general/gen053.svg'
                                className='svg-icon-2'
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold py-3'>
                              <Dropdown.Item
                                onClick={() => setShowExpensesFast(true)}
                                className='menu-item px-3'
                              >
                                <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                                  {intl.formatMessage({ id: 'BUTTON.EXPENSES.FAST.ADD' })}
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => setShowExpensesDetail(true)}
                                className='menu-item px-3'
                              >
                                <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                                  {intl.formatMessage({ id: 'BUTTON.EXPENSES.DETAIL.ADD' })}
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => setShowStatement(true)}
                                className='menu-item px-3'
                              >
                                <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                                  {intl.formatMessage({ id: 'BUTTON.STATEMENT' })}
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => setShowArchive(true)}
                                className='menu-item px-3'
                              >
                                <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                                  {intl.formatMessage({ id: 'BUTTON.ARCHIVE' })}
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => setShow(true)}
                                className='menu-item px-3'
                              >
                                <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                                  {intl.formatMessage({ id: 'BUTTON.DELETE' })}
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex flex-wrap flex-stack'>
                      <div className='d-flex flex-column flex-grow-1 pe-8'>
                        <div className='d-flex flex-wrap'>
                          <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                            <div className='fw-semibold fs-6 text-gray-400'>
                              {intl.formatMessage({ id: 'COMPANY.GET.BALANCE' })}
                            </div>
                            <div className='fw-bold fs-4'>
                              <span className='fw-bold fs-6'>
                                {intl.formatNumber(detail.balance, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                })}{' '}
                                {detail.balanceInformation}
                              </span>
                            </div>
                          </div>

                          {detail?.totalExpenses > 0 && (
                            <>
                              <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                                <div className='fw-semibold fs-6 text-gray-400'>
                                  {intl.formatMessage({ id: 'COMPANY.GET.TOTALEXPENSES' })}
                                </div>
                                <div className='fw-bold fs-4'>
                                  {intl.formatNumber(detail.totalExpenses, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              </div>

                              <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                                <div className='fw-semibold fs-6 text-gray-400'>
                                  {intl.formatMessage({ id: 'COMPANY.GET.TOTALEXPENSESBALANCE' })}
                                </div>
                                <div className='fw-bold fs-4'>
                                  {intl.formatNumber(detail.totalExpenseBalances, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              </div>
                            </>
                          )}

                          {detail?.totalSales > 0 && (
                            <>
                              <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                                <div className='fw-semibold fs-6 text-gray-400'>
                                  {intl.formatMessage({ id: 'COMPANY.GET.TOTALSALES' })}
                                </div>
                                <div className='fw-bold fs-4'>
                                  {intl.formatNumber(detail.totalSales, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              </div>

                              <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                                <div className='fw-semibold fs-6 text-gray-400'>
                                  {intl.formatMessage({ id: 'COMPANY.GET.TOTALSALESBALANCE' })}
                                </div>
                                <div className='fw-bold fs-4'>
                                  {intl.formatNumber(detail.totalSaleBalances, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              </div>
                            </>
                          )}

                          {detail?.totalTaskWork > 0 && (
                            <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                              <div className='fw-semibold fs-6 text-gray-400'>
                                {intl.formatMessage({ id: 'COMPANY.GET.TOTALTASKWORK' })}
                              </div>
                              <div className='fw-bold fs-4'>{detail.totalTaskWork}</div>
                            </div>
                          )}

                          {detail?.completedTaskWork > 0 && (
                            <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                              <div className='fw-semibold fs-6 text-gray-400'>
                                {intl.formatMessage({ id: 'COMPANY.GET.COMPLETEDTASKWORK' })}
                              </div>
                              <div className='fw-bold fs-4'>{detail.completedTaskWork}</div>
                            </div>
                          )}

                          {detail?.completionRateOfTaskWork > 0 && (
                            <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                              <div className='fw-semibold fs-6 text-gray-400'>
                                {intl.formatMessage({ id: 'COMPANY.GET.COMPLETIONRATEOFTASKWORK' })}
                              </div>
                              <div className='fw-bold fs-4'>%{detail.completionRateOfTaskWork}</div>
                            </div>
                          )}

                          {detail?.totalWitholding > 0 && (
                            <>
                              <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                                <div className='fw-semibold fs-6 text-gray-400'>
                                  {intl.formatMessage({ id: 'COMPANY.GET.TOTALWITHHOLDING' })}
                                </div>
                                <div className='fw-bold fs-4'>
                                  {intl.formatNumber(detail.totalWitholding, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {detail?.iban && (
                    <div className='notice d-flex rounded border-primary border border-dashed  p-6'>
                      {detail?.iban}
                    </div>
                  )}
                </KTCardBody>
              </KTCard>

              <KTCard>
                <KTCardBody className='p-9'>
                  <Tabs className='nav-line-tabs' fill>
                    <Tab eventKey='general' title={intl.formatMessage({ id: 'GENERAL' })}>
                      <div className='row p-5'>
                        <div className='col-lg-10 order-2 order-lg-1'>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TITLE' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.title}</span>
                            </div>
                          </div>

                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.COMMERCIALENTERPRISETYPE' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>
                                {detail.commercialEnterpriseTypeName}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.IDENTITYNUMBER' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.identityNumber}</span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TAXOFFICE' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.taxOffice}</span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TAXNUMBER' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.taxNumber}</span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.FAX' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.fax}</span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TOTALPAYMENT' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>
                                {intl.formatNumber(detail.totalPayment, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                })}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TOTALCOLLECTION' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>
                                {intl.formatNumber(detail.totalCollection, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                })}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.TOTALCHECKPAYMENT' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>
                                {intl.formatNumber(detail.totalCheckPayment, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                })}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.GIBINVOICETYPE' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.gibInvoiceTypeName}</span>
                            </div>
                          </div>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-bold text-muted'>
                              {intl.formatMessage({ id: 'COMPANY.GET.INVOICEEMAIL' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                              <span className='fw-bold fs-6'>{detail.invoiceEmail}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>

                    {accountList?.length > 0 && (
                      <Tab
                        eventKey='accountList'
                        title={intl.formatMessage({ id: 'COMPANY.GET.CHECKOUTS' })}
                      >
                        <DataTables
                          initialOrder='asc'
                          columns={[
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.FROMACCOUNTNAME',
                              }),
                              prop: 'fromAccountName',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {row.fromAccountName}
                                  {row.name && (
                                    <span className='text-muted fw-semibold d-block'>
                                      {row.name}
                                    </span>
                                  )}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.PAYMENTDELIVERYDATE',
                              }),
                              prop: 'paymentDate',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {intl.formatDate(new Date(row?.paymentDate), {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  })}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.DEFERMENTDATE',
                              }),
                              prop: 'defermentDate',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {row.defermentDate != null
                                    ? intl.formatDate(new Date(row?.defermentDate), {
                                      year: 'numeric',
                                      month: 'long',
                                      day: 'numeric',
                                    })
                                    : '-'}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.PROCESSTYPENAME',
                              }),
                              prop: 'processTypeName',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {row.processTypeName}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.ISOFFICIALNAME',
                              }),
                              prop: 'isOfficialName',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {row.isOfficialName}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'BANKCASHACCOUNT.GET.AMOUNT',
                              }),
                              prop: 'amount',
                              cell: (row) => (
                                <div
                                  className='text-dark fw-semibold d-block mb-1 fs-6 cursor-pointer'
                                  onClick={() => setCheckoutId(row.id)}
                                >
                                  {intl.formatNumber(row.amount, {
                                    style: 'currency',
                                    currency: 'try',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                          ]}
                          data={accountList}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.CHECKOUTS' })}
                        />
                      </Tab>
                    )}

                    {detail?.expenseInvoices?.length > 0 && (
                      <Tab
                        eventKey='expenseInvoices'
                        title={intl.formatMessage({ id: 'COMPANY.GET.EXPENSES' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.EXPENSEINVOICES.NAME' }),
                              prop: 'name',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(ExpenseDetailPage[row?.expenseTypeId], row?.id)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.name}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.PROJECTNAME',
                              }),
                              prop: 'projectName',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Project, row?.projectId)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.projectName}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.COMPANYNAME',
                              }),
                              prop: 'companyName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.EDITDATE',
                              }),
                              prop: 'editDate',
                              cell: (row) =>
                                intl.formatDate(new Date(row?.editDate), {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                }),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.EXPENSEPAYMENTSTATUSANDINVOICEKIND',
                              }),
                              prop: 'expensePaymentStatusName',
                              cell: (row) =>
                                row?.expensePaymentStatusName + ' / ' + row?.invoiceKindName,
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.TOTALPRICEPLUSWITHHOLDING',
                              }),
                              prop: 'totalPricePlusWithHolding',
                              cell: (row) =>
                                intl.formatNumber(row.totalPricePlusWithHolding, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.PAYMENTPRICE',
                              }),
                              prop: 'totalPrice',
                              cell: (row) =>
                                intl.formatNumber(row.totalPrice, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.WITHHOLDING',
                              }),
                              prop: 'totalWitholding',
                              cell: (row) =>
                                intl.formatNumber(row.totalWitholding, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.BALANCE',
                              }),
                              prop: 'balance',
                              cell: (row) =>
                                intl.formatNumber(row.balance, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                          ]}
                          data={detail?.expenseInvoices}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.EXPENSES' })}
                        />
                      </Tab>
                    )}

                    {detail?.saleInvoices?.length > 0 && (
                      <Tab
                        eventKey='saleInvoices'
                        title={intl.formatMessage({ id: 'COMPANY.GET.SALEINVOICES' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.SALEINVOICES.NAME' }),
                              prop: 'name',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.SaleInvoice, row?.id)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.name}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.SALEINVOICES.PROJECTNAME',
                              }),
                              prop: 'projectName',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Project, row?.projectId)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.projectName}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.SALEINVOICES.COMPANYNAME',
                              }),
                              prop: 'companyName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.SALEINVOICES.EDITDATE' }),
                              prop: 'editDate',
                              cell: (row) =>
                                intl.formatDate(new Date(row?.editDate), {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                }),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.SALEINVOICES.SALEPAYMENTSTATUSNAME',
                              }),
                              prop: 'salePaymentStatusName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.INVOICEKINDNAME',
                              }),
                              prop: 'invoiceKindName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.SALEINVOICES.TOTALPRICE',
                              }),
                              prop: 'totalPrice',
                              cell: (row) =>
                                intl.formatNumber(row.totalPrice, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.SALEINVOICES.BALANCE' }),
                              prop: 'balance',
                              cell: (row) =>
                                intl.formatNumber(row.balance, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                          ]}
                          data={detail?.saleInvoices}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.SALEINVOICES' })}
                        />
                      </Tab>
                    )}

                    {detail?.projects?.length > 0 && (
                      <Tab
                        eventKey='projects'
                        title={intl.formatMessage({ id: 'COMPANY.GET.PROJECTS' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.EXPENSEINVOICES.NAME' }),
                              prop: 'name',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Project, row?.id)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.name}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.EXPENSETOTAL',
                              }),
                              prop: 'expenseTotal',
                              cell: (row) =>
                                intl.formatNumber(row.expenseTotal, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.EXPENSEBALANCETOTAL',
                              }),
                              prop: 'expenseBalanceTotal',
                              cell: (row) =>
                                intl.formatNumber(row.expenseBalanceTotal, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.SALETOTAL',
                              }),
                              prop: 'saleTotal',
                              cell: (row) =>
                                intl.formatNumber(row.saleTotal, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.EXPENSEINVOICES.SALEBALANCETOTAL',
                              }),
                              prop: 'saleBalanceTotal',
                              cell: (row) =>
                                intl.formatNumber(row.saleBalanceTotal, {
                                  style: 'currency',
                                  currency: 'try',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 4,
                                }),
                              isSortable: true,
                              isFilterable: true,
                              alignment: {
                                horizontal: 'right',
                              },
                            },
                          ]}
                          data={detail?.projects}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.PROJECTS' })}
                        />
                      </Tab>
                    )}

                    {detail?.companyPeoples?.length > 0 && (
                      <Tab
                        eventKey='companyPeoples'
                        title={intl.formatMessage({ id: 'COMPANY.GET.COMPANYPEOPLE' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.CREATE.COMPANYPEOPLE.NAMESURNAME',
                              }),
                              prop: 'nameSurname',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.CREATE.COMPANYPEOPLE.PHONE' }),
                              prop: 'phone',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.CREATE.COMPANYPEOPLE.EMAIL' }),
                              prop: 'email',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.CREATE.COMPANYPEOPLE.DESCRIPTION',
                              }),
                              prop: 'description',
                              isSortable: true,
                              isFilterable: true,
                            },
                          ]}
                          data={detail?.companyPeoples}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.COMPANYPEOPLE' })}
                        />
                      </Tab>
                    )}

                    {detail?.checkPayments?.length > 0 && (
                      <Tab
                        eventKey='checkPayments'
                        title={intl.formatMessage({ id: 'COMPANY.GET.CHECKPAYMENTS' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.CHECKPAYMENTS.NAME' }),
                              prop: 'name',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CHECKPAYMENTS.DEFERMENTDATE',
                              }),
                              prop: 'defermentDate',
                              cell: (row) =>
                                intl.formatDate(new Date(row?.defermentDate), {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                }),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CHECKPAYMENTS.PAYMENTDATE.UPDATE',
                              }),
                              prop: 'paymentDate',
                              cell: (row) =>
                                intl.formatDate(new Date(row?.paymentDate), {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                }),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.CHECKPAYMENTS.PROJECTID' }),
                              prop: 'projectName',
                              cell: (row) => row?.projectName ? row?.projectName : '-',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.CHECKPAYMENTS.AMOUNT' }),
                              prop: 'amount',
                              cell: (row) =>
                                intl.formatNumber(row.amount, { style: 'currency', currency: 'try' }),
                              isSortable: true,
                              isFilterable: true,
                            },
                          ]}
                          data={detail?.checkPayments}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.CHECKPAYMENTS' })}
                        />
                      </Tab>
                    )}

                    {detail?.contracts?.length > 0 && (
                      <Tab
                        eventKey='contracts'
                        title={intl.formatMessage({ id: 'COMPANY.GET.CONTRACTS' })}
                      >
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.CONTRACTS.NAME' }),
                              prop: 'name',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Contract, row?.id)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.name}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.PROJECTNAME',
                              }),
                              prop: 'projectName',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Project, row?.projectId)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.projectName}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.CONTRACTTYPENAME',
                              }),
                              prop: 'contractTypeName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.CONTRACTSTATENAME',
                              }),
                              prop: 'contractStateName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.COMPANYNAME',
                              }),
                              prop: 'companyName',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.CompanySupplier, row?.companyId)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.companyName}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.STARTDATE',
                              }),
                              prop: 'startDate',
                              cell: (row) =>
                                row?.startDate
                                  ? intl.formatDate(new Date(row?.startDate), {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  })
                                  : '-',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.CONTRACTS.ENDDATE',
                              }),
                              prop: 'endDate',
                              cell: (row) =>
                                row?.endDate
                                  ? intl.formatDate(new Date(row?.endDate), {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  })
                                  : '-',
                              isSortable: true,
                              isFilterable: true,
                            },
                          ]}
                          data={detail?.contracts}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.CONTRACTS' })}
                        />
                      </Tab>
                    )}

                    {detail?.tasks?.length > 0 && (
                      <Tab eventKey='tasks' title={intl.formatMessage({ id: 'COMPANY.GET.TASKS' })}>
                        <DataTables
                          columns={[
                            {
                              title: intl.formatMessage({ id: 'COMPANY.GET.TASKS.NAME' }),
                              prop: 'name',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Task, row?.id)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.name}
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {row.description}
                                  </span>
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.PROJECTNAME',
                              }),
                              prop: 'projectName',
                              cell: (row) => (
                                <Link
                                  to={detailPageUrl(DetailPage.Project, row?.projectId)}
                                  className='text-dark text-hover-primary'
                                  target='_blank'
                                >
                                  {row.projectName}
                                </Link>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.CONSTRUCTIONSITENAME',
                              }),
                              prop: 'constructionSiteName',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.BLOCKPLOT',
                              }),
                              prop: 'blockName',
                              cell: (row) => (
                                <div className='text-dark'>
                                  {row.blockName}
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {row.plotName}
                                  </span>
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.STARTDATE',
                              }),
                              prop: 'startDate',
                              cell: (row) =>
                                row?.startDate
                                  ? intl.formatDate(new Date(row?.startDate), {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  })
                                  : '-',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.ENDDATE',
                              }),
                              prop: 'endDate',
                              cell: (row) =>
                                row?.endDate
                                  ? intl.formatDate(new Date(row?.endDate), {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  })
                                  : '-',
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.COMPLETIONRATE',
                              }),
                              prop: 'completionRate',
                              cell: (row) => (
                                <div className='text-dark text-hover-primary'>
                                  {row.completionRate ? `%${row.completionRate}` : '-'}
                                </div>
                              ),
                              isSortable: true,
                              isFilterable: true,
                            },
                            {
                              title: intl.formatMessage({
                                id: 'COMPANY.GET.TASKS.TASKSTATENAME',
                              }),
                              prop: 'taskStateName',
                              isSortable: true,
                              isFilterable: true,
                            },
                          ]}
                          data={detail?.tasks}
                          exportTitle={intl.formatMessage({ id: 'COMPANY.GET.TASKS' })}
                        />
                      </Tab>
                    )}
                  </Tabs>
                </KTCardBody>
              </KTCard>
            </>
          )}
        </div>

        <div className='col-xl-3'>
          <KTCard className='mb-5'>
            <KTCardBody className='p-3'>
              <form
                className='form position-relative mb-6'
                onSubmit={formik.handleSubmit}
                noValidate
              >
                <Tabs
                  defaultActiveKey={activeTab}
                  fill
                  onSelect={(active) => setActiveTab(active)}
                  className='nav-line-tabs'
                >
                  <Tab
                    eventKey='payment'
                    title={intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.ADD' })}
                    className='p-5'
                  >
                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'CHECK.ADDPAYMENT.PAYMENTDATE' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Datepicker
                          {...formik.getFieldProps('PaymentDate')}
                          onChange={([date]) => formik.setFieldValue('PaymentDate', date)}
                        />
                        {formik.touched.PaymentDate && formik.errors.PaymentDate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.PaymentDate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.TOACCOUNDID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={accountLookupList}
                          required
                          {...formik.getFieldProps('FromAccountId')}
                          onChange={(item) =>
                            formik.setFieldValue('FromAccountId', Number(item?.value))
                          }
                        />
                        {formik.touched.FromAccountId && formik.errors.FromAccountId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.FromAccountId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.PROJECTID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={projectLookupList}
                          required
                          {...formik.getFieldProps('ProjectId')}
                          onChange={(item) =>
                            formik.setFieldValue('ProjectId', Number(item?.value))
                          }
                        />
                        {formik.touched.ProjectId && formik.errors.ProjectId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.ProjectId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.ISOFFICIAL.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <input
                            className='form-check-input h-30px w-50px'
                            type='checkbox'
                            checked={formik.values.IsOfficial}
                            {...formik.getFieldProps('IsOfficial')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <InputPrice
                          {...formik.getFieldProps('Amount')}
                          onChange={(value) => formik.setFieldValue('Amount', Number(value))}
                        />
                        {formik.touched.Amount && formik.errors.Amount && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.Amount}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.NAME' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <textarea
                          className='form-control form-control-solid mb-3 mb-lg-0'
                          autoComplete='off'
                          disabled={formik.isSubmitting}
                          rows={2}
                          {...formik.getFieldProps('Name')}
                        />
                      </div>
                    </div>

                    <div className='text-center'>
                      <button
                        type='submit'
                        className='btn btn-primary'
                        data-kt-users-modal-action='submit'
                        disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                      >
                        <span className='indicator-label'>
                          {intl.formatMessage({ id: 'BUTTON.SUBMIT' })}
                        </span>
                        {formik.isSubmitting && (
                          <span className='indicator-progress'>
                            {intl.formatMessage({ id: 'PLEASE' })}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </Tab>

                  <Tab
                    eventKey='collection'
                    title={intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.ADD' })}
                    className='p-5'
                  >
                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.COLLECTIONDATE' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Datepicker
                          {...formik.getFieldProps('PaymentDate')}
                          onChange={([date]) => formik.setFieldValue('PaymentDate', date)}
                        />
                        {formik.touched.PaymentDate && formik.errors.PaymentDate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.PaymentDate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.TOACCOUNDID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={accountLookupList}
                          required
                          {...formik.getFieldProps('ToAccountId')}
                          onChange={(item) =>
                            formik.setFieldValue('ToAccountId', Number(item?.value))
                          }
                        />
                        {formik.touched.ToAccountId && formik.errors.ToAccountId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.ToAccountId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.PROJECTID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={projectLookupList}
                          required
                          {...formik.getFieldProps('ProjectId')}
                          onChange={(item) =>
                            formik.setFieldValue('ProjectId', Number(item?.value))
                          }
                        />
                        {formik.touched.ProjectId && formik.errors.ProjectId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.ProjectId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.ISOFFICIAL.COLLECTION' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <input
                            className='form-check-input h-30px w-50px'
                            type='checkbox'
                            checked={formik.values.IsOfficial}
                            {...formik.getFieldProps('IsOfficial')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <InputPrice
                          {...formik.getFieldProps('Amount')}
                          onChange={(value) => formik.setFieldValue('Amount', Number(value))}
                        />
                        {formik.touched.Amount && formik.errors.Amount && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.Amount}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.DESCRIPTION' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <textarea
                          type='text'
                          className='form-control form-control-solid mb-3 mb-lg-0'
                          autoComplete='off'
                          disabled={formik.isSubmitting}
                          rows={2}
                          {...formik.getFieldProps('Name')}
                        />
                      </div>
                    </div>

                    <div className='text-center'>
                      <button
                        type='submit'
                        className='btn btn-primary'
                        data-kt-users-modal-action='submit'
                        disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                      >
                        <span className='indicator-label'>
                          {intl.formatMessage({ id: 'BUTTON.SUBMIT' })}
                        </span>
                        {formik.isSubmitting && (
                          <span className='indicator-progress'>
                            {intl.formatMessage({ id: 'PLEASE' })}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </Tab>

                  <Tab
                    eventKey='check'
                    title={intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.SAVEDCHECK' })}
                    className='p-5'
                  >
                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.CHECK' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={usablecheckLookup}
                          required
                          {...formik.getFieldProps('CheckId')}
                          onChange={(item) => formik.setFieldValue('CheckId', Number(item?.value))}
                        />
                        {formik.touched.CheckId && formik.errors.CheckId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.CheckId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.ISOFFICIAL.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <input
                            className='form-check-input h-30px w-50px'
                            type='checkbox'
                            checked={formik.values.IsOfficial}
                            {...formik.getFieldProps('IsOfficial')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.DESCRIPTION' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <textarea
                          className='form-control form-control-solid mb-3 mb-lg-0'
                          autoComplete='off'
                          disabled={formik.isSubmitting}
                          rows={2}
                          {...formik.getFieldProps('Name')}
                        />
                      </div>
                    </div>

                    <div className='text-center'>
                      <button
                        type='submit'
                        className='btn btn-primary'
                        data-kt-users-modal-action='submit'
                        disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                      >
                        <span className='indicator-label'>
                          {intl.formatMessage({ id: 'BUTTON.SUBMIT' })}
                        </span>
                        {formik.isSubmitting && (
                          <span className='indicator-progress'>
                            {intl.formatMessage({ id: 'PLEASE' })}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </Tab>

                  <Tab
                    eventKey='newcheck'
                    title={intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.NEWCHECK' })}
                    className='p-5'
                  >
                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.BANKID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={Bank}
                          required
                          {...formik.getFieldProps('BankId')}
                          onChange={(item) => formik.setFieldValue('BankId', Number(item?.value))}
                        />
                        {formik.touched.BankId && formik.errors.BankId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.BankId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.CHECKNO' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <input
                          type='text'
                          className='form-control form-control-solid mb-3 mb-lg-0'
                          autoComplete='off'
                          disabled={formik.isSubmitting}
                          {...formik.getFieldProps('CheckNo')}
                        />
                        {formik.touched.CheckNo && formik.errors.CheckNo && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.CheckNo}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.EDITDATE' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Datepicker
                          {...formik.getFieldProps('EditDate')}
                          onChange={([date]) => formik.setFieldValue('EditDate', date)}
                        />
                        {formik.touched.EditDate && formik.errors.EditDate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.EditDate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.DEFERMENTDATE' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Datepicker
                          {...formik.getFieldProps('DefermentDate')}
                          onChange={([date]) => formik.setFieldValue('DefermentDate', date)}
                        />
                        {formik.touched.DefermentDate && formik.errors.DefermentDate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.DefermentDate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2 required'>
                        {intl.formatMessage({ id: 'SALEINVOICE.GET.RECIEVE.ISOFFICIAL.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <input
                            className='form-check-input h-30px w-50px'
                            type='checkbox'
                            checked={formik.values.IsOfficial}
                            {...formik.getFieldProps('IsOfficial')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.PAYMENT' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <InputPrice
                          {...formik.getFieldProps('TotalPrice')}
                          onChange={(value) => formik.setFieldValue('TotalPrice', Number(value))}
                        />
                        {formik.touched.TotalPrice && formik.errors.TotalPrice && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.TotalPrice}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.PROJECTID' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <Select
                          data={projectLookupList}
                          {...formik.getFieldProps('ProjectId')}
                          onChange={(item) =>
                            formik.setFieldValue('ProjectId', Number(item?.value))
                          }
                        />
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-12 fw-bold fs-6 mb-2'>
                        {intl.formatMessage({ id: 'EXPENSEINVOICE.GETDETAIL.RECIEVE.DESCRIPTION' })}
                      </label>
                      <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                        <textarea
                          type='text'
                          className='form-control form-control-solid mb-3 mb-lg-0'
                          autoComplete='off'
                          disabled={formik.isSubmitting}
                          rows={2}
                          {...formik.getFieldProps('Description')}
                        />
                      </div>
                    </div>

                    <div className='text-center'>
                      <button
                        type='submit'
                        className='btn btn-primary'
                        data-kt-users-modal-action='submit'
                        disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                      >
                        <span className='indicator-label'>
                          {intl.formatMessage({ id: 'BUTTON.SUBMIT' })}
                        </span>
                        {formik.isSubmitting && (
                          <span className='indicator-progress'>
                            {intl.formatMessage({ id: 'PLEASE' })}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </Tab>
                </Tabs>
              </form>
            </KTCardBody>
          </KTCard>

          <Notes SourceId={Number(id)} SourceTypeId={SourceType.Company} />
        </div>
      </div>

      <DeleteModal
        onClick={handlers.handleDelete}
        onOpen={show}
        onClose={() => setShow(false)}
        error={error}
      />

      <ArchiveModal
        onClick={handlers.handleArchive}
        onOpen={showArchive}
        onClose={() => setShowArchive(false)}
        error={error}
      />

      <CheckoutDetail id={checkoutId} onClose={() => setCheckoutId(null)} />

      <StatementModal
        onOpen={showStatement}
        CompanyId={id}
        onClose={() => setShowStatement(false)}
      />

      <ContentModal
        onOpen={showExpensesFast}
        onClose={() => setShowExpensesFast(false)}
        error={error}
        title={intl.formatMessage({ id: 'BC.EXPENSES.FAST.ADD' })}
      >
        {showExpensesFast && <ExpensesFast CompanyId={id} />}
      </ContentModal>

      <ContentModal
        onOpen={showExpensesDetail}
        onClose={() => setShowExpensesDetail(false)}
        error={error}
        title={intl.formatMessage({ id: 'BC.EXPENSES.DETAIL.ADD' })}
      >
        {showExpensesDetail && <ExpensesDetail CompanyId={id} />}
      </ContentModal>

      {loading && <Loading />}
    </>
  )
}

export { Detail }
